import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation } from 'src/components/pages/Navigation/Navigation';
import { PageContainer } from 'src/components/shared/Container/Container';
import { AppRoutes } from 'src/routes';
import { useReduxDispatch } from 'src/store/index';
import { useAuth } from './components/pages/Auth/AuthContext';
import { fetchCustomers } from './store/customers/customers.actions';
import { fetchGrades } from './store/grades/grades.actions';
import { fetchInstruments } from './store/instruments/instruments.actions';
import { fetchLabelTemplates } from './store/labelTemplates/labelTemplates.actions';
import { fetchMethods } from './store/methods/methods.actions';
import { fetchMixtureStatuses } from './store/mixtures/mixtures.actions';
import { fetchMixtureTypes } from './store/mixturetypes/mixturetypes.actions';
import { fetchPackagings } from './store/packagings/packagings.actions';
import { fetchPallets } from './store/pallets/pallets.actions';
import { fetchParameters } from './store/parameters/parameters.actions';
import {
  fetchParameterSets,
  fetchParameterSetTypes
} from './store/parametersets/parametersets.actions';
import { fetchPlants } from './store/plants/plants.actions';
import { fetchProductStatuses } from './store/products/products.actions';
import { fetchProductTypes } from './store/producttypes/producttypes.actions';
import { fetchRecipients } from './store/recipients/recipients.actions';
import {
  fetchRunSystemArchiving,
  fetchRunSystems
} from './store/runsystems/runsystems.actions';
import { fetchSegments } from './store/segments/segments.actions';
import { fetchSpecifications } from './store/specifications/specifications.actions';
import { Transitions } from './Transitions';
import { useNoScroll } from './utils/noScroll';

export const App = () => {
  const { isAuthenticated } = useAuth();
  const dispatch = useReduxDispatch();
  const location = useLocation();
  useNoScroll();

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchRunSystems());
      dispatch(fetchRunSystemArchiving());
      dispatch(fetchPlants());
      dispatch(fetchProductTypes());
      dispatch(fetchMixtureTypes());
      dispatch(fetchCustomers());
      dispatch(fetchRecipients());
      dispatch(fetchSegments());
      dispatch(fetchInstruments());
      dispatch(fetchGrades());
      dispatch(fetchPallets());
      dispatch(fetchLabelTemplates());
      dispatch(fetchPackagings());
      dispatch(fetchParameterSets());
      dispatch(fetchParameters());
      dispatch(fetchMethods());
      dispatch(fetchProductStatuses());
      dispatch(fetchSpecifications());
      dispatch(fetchMixtureStatuses());
      dispatch(fetchParameterSets());
      dispatch(fetchParameterSetTypes());
    }
  }, [dispatch, isAuthenticated]);

  return (
    <>
      <Navigation />
      <PageContainer>
        <Transitions location={location}>
          <AppRoutes location={location} />
        </Transitions>
      </PageContainer>
    </>
  );
};
